import { createIcon } from '@chakra-ui/icons';

const Conforme = createIcon({
  path: (
    <g data-id="1b583313884a">
     <circle cx="15" cy="15" fill="white" r="15"/>
<path clipRule="evenodd" d="M21.5246 8.47531C21.9152 8.08479 21.918 7.44731 21.4914 7.09653C19.7256 5.6445 17.4646 4.77271 15 4.77271C9.35161 4.77271 4.77271 9.35161 4.77271 15C4.77271 20.6483 9.35161 25.2272 15 25.2272C17.4646 25.2272 19.7256 24.3555 21.4914 22.9034C21.918 22.5526 21.9152 21.9152 21.5246 21.5246L20.0461 20.0461C19.6556 19.6556 19.0263 19.6635 18.5779 19.9859C17.5706 20.7099 16.3351 21.1363 15 21.1363C11.611 21.1363 8.86361 18.389 8.86361 15C8.86361 11.611 11.611 8.86361 15 8.86361C16.3351 8.86361 17.5706 9.29001 18.5779 10.0141C19.0263 10.3364 19.6556 10.3443 20.0461 9.9538L21.5246 8.47531Z" fill="#462AC4" fillRule="evenodd"/>
<circle cx="15" cy="15" fill="#462AC4" r="3.40909"/>
    </g>
  ),
  viewBox: '0 0 30 30',
});

export default Conforme;
